module.exports = __webpack_public_path__ + "static/media/footerImg.6e7f0a30.png";